// extracted by mini-css-extract-plugin
module.exports = {"pebbleButton":"NewNameNotice_pebbleButton__qWWig"};